import { SET_VALUES_DIGITAL_FORM, CLEAR_VALUES_DIGITAL_FORM } from '@constants/actionType'

const initialState = {
  general: null,
};

function surveysState(state = initialState, actions) {
  switch (actions.type) {
    case SET_VALUES_DIGITAL_FORM:
      return { ...state, ...actions.payload };
    case CLEAR_VALUES_DIGITAL_FORM:
      return {
        general: null,
      };
    default:
      return state;
  }
}

export default surveysState;
